import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { replyToConversation, updateReplyText } from 'redux/modules/messageCenter';
import * as styles from './InstagramReplyField.scss';
var InstagramReplyField = (_dec = connect(function (state) {
  return {
    organization: state.organization.current,
    theme: state.theme,
    isReplyingToConversation: state.messageCenter.isReplyingToConversation
  };
}, {
  replyToConversation: replyToConversation,
  updateReplyText: updateReplyText
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(InstagramReplyField, _Component);

  var _super = _createSuper(InstagramReplyField);

  function InstagramReplyField() {
    var _this;

    _classCallCheck(this, InstagramReplyField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (e) {
      var _this$props = _this.props,
          conversationId = _this$props.conversationId,
          organization = _this$props.organization,
          parent = _this$props.parent;

      if (e.key === 'Enter') {
        var orgId = _this.props.organization.id;
        var reply = {
          text: e.target.value,
          authorSocialAccountId: _this.getSocialAccount().id
        };
        console.log(reply);

        _this.props.replyToConversation(orgId, conversationId, reply);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getSocialAccount", function () {
      var _this$props2 = _this.props,
          organization = _this$props2.organization,
          parent = _this$props2.parent;
      var sa = false;
      console.log('in getSocialAccount()');
      console.log(parent);

      if (parent.details && parent.details.user) {
        organization.SocialAccounts.forEach(function (a) {
          if (a.platformId === parent.details.user.id) {
            sa = a;
          }
        });
      } else {
        // otherwise, look through and find the Instagram account
        for (var i = 0; i < _this.props.organization.SocialAccounts.length; i++) {
          var a = _this.props.organization.SocialAccounts[i];

          if (a.platform === 'Instagram') {
            sa = a;
          }
        }
      }

      return sa;
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (e) {
      if (_this.props.item && (_this.props.item.ConversationId || _this.props.item.parentMessageId)) {
        _this.props.updateReplyText(e.target.value, _this.props.conversationId, _this.props.item.id);
      } else if (_this.props.parent) {
        _this.props.updateReplyText(e.target.value, _this.props.conversationId);
      }
    });

    return _this;
  }

  _createClass(InstagramReplyField, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          item = _this$props3.item,
          parent = _this$props3.parent;
      var replyText = (item ? item.replyText : this.props.parent.replyText) || '';
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: styles.wrap,
        style: this.props.style
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.inputWrap,
        style: {
          flex: '1 1 auto',
          opacity: this.props.isReplyingToConversation ? '0.5' : '1'
        }
      }, /*#__PURE__*/React.createElement("input", {
        className: styles.textField,
        onKeyDown: this.handleKeyDown,
        onChange: this.handleChange,
        value: replyText,
        disabled: this.props.isReplyingToConversation,
        placeholder: "Add a comment..."
      }))));
    }
  }]);

  return InstagramReplyField;
}(Component), _defineProperty(_class2, "propTypes", {
  item: PropTypes.any,
  parent: PropTypes.any,
  replyToConversation: PropTypes.func.isRequired
}), _temp)) || _class);
export default InstagramReplyField;